import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant table-hover" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "ID", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Party ID", -1)
const _hoisted_8 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_9 = { colspan: "12" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["onClick"]

import { ref, onMounted } from "vue";
import ReportService from "../services/ReportService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import recordDetail from "../components/messageRecord/recordDetail.vue";
import {
  MessageRecordStatus,
  messageRecordStatusOptions,
} from "@/core/types/messageRecord/messageRecordStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageRecord',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>([]);
const recordDetailRef = ref<any>(null);
const accountSelected = ref(0);

const criteria = ref<any>({
  page: 1,
  size: 20,
});

const view = (item: any) => {
  recordDetailRef.value.show(item);
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
  };
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await ReportService.queryMessageRecords(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};
const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.event,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.event) = $event)),
            placeholder: _ctx.$t('fields.event'),
            disabled: isLoading.value,
            clearable: "",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.eventId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.eventId) = $event)),
            placeholder: _ctx.$t('fields.eventId'),
            disabled: isLoading.value,
            class: "ms-4",
            clearable: "",
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.receiver,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.receiver) = $event)),
            placeholder: _ctx.$t('fields.email'),
            disabled: isLoading.value,
            class: "ms-4",
            clearable: "",
            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.receiverPartyId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.receiverPartyId) = $event)),
            placeholder: "Party ID",
            disabled: isLoading.value,
            class: "ms-4",
            clearable: "",
            onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.method,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.method) = $event)),
            placeholder: _ctx.$t('fields.method'),
            disabled: isLoading.value,
            class: "ms-4",
            clearable: "",
            onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.status,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((criteria.value.status) = $event)),
            disabled: isLoading.value,
            placeholder: _ctx.$t('fields.status'),
            class: "ms-4",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageRecordStatusOptions), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "placeholder"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (fetchData(1))),
            plain: "",
            loading: isLoading.value,
            class: "ms-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: reset,
            disabled: isLoading.value,
            class: "ms-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.receiver")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.receiverName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.method")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.eventId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.event")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.receiverPartyId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.receiver), 1),
                      _createElementVNode("td", null, _toDisplayString(item.receiverName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.method), 1),
                      _createElementVNode("td", null, _toDisplayString(item.eventId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.event), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`status.${_unref(MessageRecordStatus)[item.status]}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.note), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          plain: "",
                          size: "small",
                          onClick: ($event: any) => (view(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 10, _hoisted_12))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(recordDetail, {
      ref_key: "recordDetailRef",
      ref: recordDetailRef
    }, null, 512)
  ], 64))
}
}

})